import { ApiService } from "src/app/services/api.service";
import { FavService } from "./../../services/fav.service";
import { SignalRService } from "src/app/services/signalr.service";
import { GridsterService } from "./../../services/gridster.service";
import { TranslateService } from "@ngx-translate/core";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { CompanyList } from "src/app/models/company-list";
import {
  ColumnMode,
  DatatableComponent,
  SelectionType,
} from "@swimlane/ngx-datatable";
import { ContextMenuComponent } from "ngx-contextmenu";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
  selector: "app-market-watch-table",
  templateUrl: "./market-watch-table.component.html",
  styleUrls: ["./market-watch-table.component.scss"],
})
export class MarketWatchTableComponent implements OnInit {
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;

  fireFunction: any;
  addWidget: any;

  isCompaniesLoading: boolean;
  companies: CompanyList[] = [];
  egxCompanies: CompanyList[] = [];
  favCompanies: CompanyList[];
  searchText = "";
  selectedSymbol: any;
  ColumnMode = ColumnMode;
  @ViewChild(DatatableComponent) table: DatatableComponent;
  searchComp: CompanyList[];
  selected = [];
  SelectionType = SelectionType;

  @ViewChild("myWidget") myWidget: ElementRef;

  public contextmenuX: any;
  public contextmenuY: any;
  public contextmenu = false;
  addWidgetSymbolCode: any;
  columns = [];
  matColumns = [
    "Reuters",
    "ENG_NAME",
    "LAST_TRADE_PRICE",
    "LAST_TRADE_VOLUME",
    "LAST_CHANGE",
    "LAST_CHANGE_PRC",
    "OPEN_PRICE",
    "CLOSE_PRICE",
    "LOW_PRICE",
    "HIGH_PRICE",
    "TOTAL_VALUE",
    "TOTAL_VOLUME",
    "BID_PRICE",
    "BID_VOLUME",
    "TOTAL_BIDS",
    "TOTAL_ASKS",
    "ASK_VOLUME",
    "ASK_PRICE",
    "ENG_DESC",
    "MARKET_ID",
    "PREVIOUS_CLOSE",
    "REF_PRICE",
  ];
  allFilters = [
    { prop: "LAST_TRADE_PRICE", name: "last-price", isChecked: true },
    { prop: "LAST_TRADE_VOLUME", name: "last-volume", isChecked: true },
    { prop: "LAST_CHANGE", name: "last-change", isChecked: true },
    {
      prop: "LAST_CHANGE_PRC",
      name: "last-change-prc",
      isChecked: true,
    },
    { prop: "OPEN_PRICE", name: "open", isChecked: true },
    { prop: "CLOSE_PRICE", name: "close", isChecked: true },
    { prop: "LOW_PRICE", name: "low", isChecked: true },
    { prop: "HIGH_PRICE", name: "high", isChecked: true },
    { prop: "TOTAL_VALUE", name: "value", isChecked: true },
    { prop: "TOTAL_VOLUME", name: "volume", isChecked: true },
    { prop: "BID_PRICE", name: "bid-price", isChecked: false },
    { prop: "BID_VOLUME", name: "bid-qty", isChecked: false },
    { prop: "TOTAL_BIDS", name: "total-bids", isChecked: false },
    { prop: "TOTAL_ASKS", name: "total-asks", isChecked: false },
    { prop: "ASK_VOLUME", name: "ask-qty", isChecked: false },
    { prop: "ASK_PRICE", name: "ask-price", isChecked: false },
    { prop: "ENG_DESC", name: "sector", isChecked: false },
    { prop: "MARKET_ID", name: "market", isChecked: false },
    { prop: "PREVIOUS_CLOSE", name: "prev-close", isChecked: false },
    { prop: "REF_PRICE", name: "ref-price", isChecked: false },
  ];

  tableView = "market";
  favView = "grid";

  companiesUpdates: CompanyList[] = [];
  isFavsLoading: boolean = false;

  public onFavViewChange(val: string) {
    this.favView = val;
  }

  reordered(event) {
  }

  clickedOutsideMenu() {
    this.contextmenu = false;
  }

  public onTableContextMenu(event) {
    // NOTE: click on header pls check when use
    let rect = this.myWidget.nativeElement.getBoundingClientRect();

    this.contextmenuX = event.event.clientX - rect.left;
    this.contextmenuY = event.event.clientY - rect.top + 80;

    this.contextmenu = true;
    this.addWidgetSymbolCode = {
      symbol: event.content.SYMBOL_CODE,
      reuters: event.content.Reuters,
      name: event.content.ARB_NAME,
      nameEn: event.content.ENG_NAME,
    };
    event.event.preventDefault();
    event.event.stopPropagation();
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
  }

  isNumber(val): boolean {
    return typeof val === "number";
  }

  getCellClass({ row, column, value }): any {
    if (row.SYMBOL_STATE == "S") return { suspended: true };

    // if (
    //   (column.prop == "LAST_CHANGE_PRC" && value > 0) ||
    //   (column.prop == "LAST_CHANGE" && value > 0)
    // ) {
    //   return "color : green";
    // } else if (
    //   (column.prop == "LAST_CHANGE_PRC" && value != 0) ||
    //   (column.prop == "LAST_CHANGE" && value != 0)
    // ) {
    //   return "color : red";
    // }
  }

  onSelect({ selected }) {
    this.sendCompanySymbol(this.selected[0].SYMBOL_CODE);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    this.updateCols();
  }
  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.companies.filter(function (d) {
      return (
        d.ENG_NAME &&
        (d.ENG_NAME.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
          d.ARB_NAME.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
          d.SYMBOL_CODE.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
          d.Reuters.toLocaleLowerCase().includes(val.toLocaleLowerCase()))
      );
    });

    // update the rows
    this.searchComp = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  constructor(
    public translate: TranslateService,
    private _gridService: GridsterService,
    signalService: SignalRService,
    private favService: FavService,
    private _service: ApiService
  ) {
    // signalService.connectMarketWatch();

    signalService.marketChanges.subscribe((res) => {
      res.forEach((update) => {
        if (this.tableView == "market" && this.companies != null) {
          let itemIndex = this.companies.findIndex(
            (item) => item.SYMBOL_CODE == update.SYMBOL_CODE
          );
          if (this.companies[itemIndex] != update) {
            this.companies[itemIndex] = update;
            this.companies[itemIndex].isUpdate = true;
          }
        }
      });
      if (this.tableView == "market" && this.companies)
        this.companies = [...this.companies];
    });
  }

  ngOnInit() {
    if (this._gridService.getMarketWatchColumns()) {
      this.columns = this._gridService.getMarketWatchColumns();
    } else {
      this.columns = this.allFilters;
    }

    // this.fetchTodayActive();
    this.fetchEGX("EGX30");
    this.WindowResize();
  }

  refreshUpdates() {
    let i = 0;
    if (this.companies) {
      this.companiesUpdates.forEach((update) => {
        let itemIndex = this.companies.findIndex(
          (item) => item.SYMBOL_CODE == update.SYMBOL_CODE
        );
        this.companies[itemIndex] = update;
      });
      i++;
    }
  }

  updateCols() {
    this._gridService.saveMarketWatchColumns(this.columns);
    this.WindowResize();
  }

  sendCompanySymbol(symbol) {
    this.selectedSymbol = symbol;
    this.fireFunction(symbol);
  }

  addWidgett(event) {
    let obj = JSON.parse(event);

    this.addWidget(obj.name, obj.companyData);
  }

  fetchFavs() {
    this.tableView = "favorites";
    this.isFavsLoading = true;

    this.favService.favCompanies.subscribe((res) => {
      this.favCompanies = res;
      this.isFavsLoading = false;
    });
  }

  getRowClass(row) {
    if (row.isUpdate == true) {
      row.isUpdate = false;
      return {
        flashit: true,
      };
    }
    // if (row.SYMBOL_STATE == "S") return { suspended: true };
  }

  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

  fetchEGX(egx) {
    this.tableView = "market";
    this.companies = [];
    this.isCompaniesLoading = true;

    this.egxCompanies = [];

    this._service.fetchEGX(egx).subscribe((res) => {
      this.isCompaniesLoading = false;
      this.companies = res as CompanyList[];
      this.WindowResize();
    });
  }

  fetchTodayActive() {
    this.tableView = "market";
    this.companies = [];
    this.isCompaniesLoading = true;

    this._service.fetchTodayMarketWatch().subscribe((res) => {
      this.isCompaniesLoading = false;
      this.companies = res as CompanyList[];
      this.WindowResize();
    });
  }

  fetchCompanies() {
    this.tableView = "market";

    this.isCompaniesLoading = true;
    this.companies = null;

    this._service.fetchAllMarketWatch().subscribe((res: CompanyList[]) => {
      this.isCompaniesLoading = false;
      this.companies = res.filter((company) => company.MARKET_ID != "INDX");
      this.WindowResize();
    });
  }

  fetchMarket(x) {
    this.tableView = "market";

    this.isCompaniesLoading = true;
    this.companies = null;

    this._service.fetchEgxMarket(x).subscribe((res: CompanyList[]) => {
      this.isCompaniesLoading = false;
      this.companies = res;
      this.WindowResize();
    });
  }

  get colsss() {
    return this.columns.filter((col) => col.isChecked);
  }

  toggle(col, event) {
    col.isChecked = !col.isChecked;

    this.WindowResize();
    this.updateCols();
  }
}
